<template>
  <div class="edit-users-overlay container-fluid"> 
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-bottom-15px">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc padding-left-4Point4 create-element-overlay-course-title-font-styles">
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="closeOverlay($event)">
              <img src= "../../../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <!-- Start notification text -->
        <div class="row vertical-align padding-top-15px padding-bottom-15px">
          <div class="col-md-1 col-md-offset-1 col-lg-1 col-lg-offset-1 create-lesson-input-text-style text-align-right padding-left-0px Padding-right-0px">Notification Title</div> 
          <div class="col-md-4 col-lg-4">
            <div class="form-group margin-bottom-0px">
              <input type="text" class="form-control" v-model="notifTitleValue">
            </div>  
          </div>
          <div class="col-md-1 col-lg-1 create-lesson-input-text-style text-align-right Padding-right-0px padding-left-0px">Notification Description</div> 
          <div class="col-md-4 col-lg-4">
            <textarea class="form-control" rows="5" v-model="notifTextValue"></textarea>  
          </div>
          <div class="col-md-1 col-lg-1"></div>
        </div>
        <!-- End of notification text -->
        <!-- Schedule TS -->
        <div class="row vertical-align margin-bottom-2Perc padding-top-15px">
          <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px Padding-right-0px">
            Schedule TS
          </div>
          <div class="col-md-4 col-lg-4">
            <date-picker v-model="date" :config="config"></date-picker>
          </div>
          <div class="col-md-6 col-lg-6"></div>
        </div>
        <!-- End of Schedule TS -->
        <div class="row margin-bottom-2Perc">
          <div class="col-md-5 col-lg-5">
          </div>  
          <div class="col-md-2 col-lg-2">
            <button class="btn btn-primary create-lesson-overlay-button-BG black-font-color" @click="updateScheduledNotifications($event)">Update Notification</button>
          </div>  
          <div class="col-md-5 col-lg-5">
          </div>
        </div>
        <div class="row">
        </div>         
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div> 
</template>
<script>
import { notificationService } from '@/server-util/notification-service'
import { constants } from '@/utils/constants'
import datePicker from 'vue-bootstrap-datetimepicker'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import AlertBox from '@/components/AlertOverlay'
export default {
  props: ['currNotifObj', 'selectedCourseMomentObj'],
  name: 'edit-users-overlay',
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      btnText: '',
      showAlertDialog: false,
      errorMsg: '',
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      notificationText: '',
      selectedStepObj: -1,
      date: new Date(),
      config: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: true,
        sideBySide: true,
        defaultDate: null
      },
      notifObj: {
        ScheduledNotificationId: '',
        GroupCourseMasterId: '',
        NotifTitle: '',
        NotifText: '',
        ScheduleTS: ''
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker
  },
  methods: {
    setDefaultValues: function () {
      this.notifObj.ScheduledNotificationId = this.getCurrNotifObj.ScheduledNotificationId
      this.notifObj.GroupCourseMasterId = this.getSelectedCourseMomentObj.GroupCourseMasterId
      this.notifObj.NotifTitle = this.getCurrNotifObj.NotifTitle
      this.notifObj.NotifText = this.getCurrNotifObj.NotifText
      this.config.defaultDate = dmAdminUtils.covertUtcToEst(this.getCurrNotifObj.ScheduleTS + 'Z')
      this.date = dmAdminUtils.covertUtcToEst(this.getCurrNotifObj.ScheduleTS + 'Z')
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of overlay
      this.showConfirmationBox = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.notifTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.notifObj.NotifTitle = this.getCurrNotifObj.NotifTitle
        this.errorMsg = 'Notification Title can\'t be empty.'
        return false
      } if (this.notifTextValue.trim().length === 0) {
        this.showAlertDialog = true
        this.notifObj.NotifText = this.getCurrNotifObj.NotifText
        this.errorMsg = 'Notification Text can\'t be empty.'
        return false
      } else if (this.date === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a release date.'
        return false
      }
      return true
    },
    updateScheduledNotifications: function (event) {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var _this = this
        var storeObj = this.$store
        if (this.notifObj.ScheduledNotificationId !== undefined) {
          _this.$store.state.isLoading = true
          // AK: Assign updated date before updating details
          this.notifObj.ScheduleTS = this.date
          notificationService
              .updateScheduledNotification(storeObj.state.access_token, _this.notifObj)
              .then(responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  // AK: Refresh Notification List
                  var objToPass = {
                    openOverlay: false,
                    refreshList: true
                  }
                  _this.$store.state.isLoading = false
                  _this.$emit('viewOverlay', objToPass)
                } else {
                  // AK: Hide Spinner
                  _this.$store.state.isLoading = false
                  this.showAlertDialog = true
                  this.errorMsg = 'Oops! Something went wrong. Please try again.'
                }
              }, errorObj => {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              })
        } else {
          console.log(
            'Scheduled Notification Id is NULL hence declined UPDATE NOTIFICATION OPERATION'
          )
        }
      }
    },
    closeOverlay: function (event) {
      var objToPass = {
        openOverlay: false,
        refreshList: false
      }
      this.$emit('viewOverlay', objToPass)
    }
  },
  computed: {
    getSelectedCourseMomentObj: {
      get: function () {
        return this.selectedCourseMomentObj
      }
    },
    getCurrNotifObj: {
      get: function () {
        return this.currNotifObj
      }
    },
    notifElementIdValue: {
      get: function () {
        return this.notifObj.ElementId
      },
      set: function (newValue) {
        this.notifObj.ElementId = newValue
      }
    },
    notifTextValue: {
      get: function () {
        return this.notifObj.NotifText
      },
      set: function (newValue) {
        this.notifObj.NotifText = newValue
      }
    },
    notifTitleValue: {
      get: function () {
        return this.notifObj.NotifTitle
      },
      set: function (newValue) {
        this.notifObj.NotifTitle = newValue
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 20%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.text-align-left {
  text-align: left !important;
}
.text-align-center {
  text-align: center !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 18px;
  color: #34495e;
}
.create-element-overlay-MOTD-title-font-styles {
  font-size: 18px;
  color: #34495e;
}
.font-size-14px {
  font-size: 14px;
}
.font-size-15px {
  font-size: 15px;
}
.create-element-overlay-Step-title-font-styles {
  font-size: 18px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
.margin-top-3Perc {
  margin-top: 3% !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.border-red {
  border: 1px solid red;
}
.margin-top-6Perc {
  margin-top: 6%;
}
.padding-top-15px {
    padding-top: 15px;
}
.padding-bottom-15px {
    padding-bottom: 15px;
}
.Padding-right-0px {
  padding-right: 0px !important;
}
.padding-left-0px {
  padding-left:0px;
}
.margin-bottom-15px {
  margin-bottom: 15px;
}
.margin-bottom-0px {
  margin-bottom:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/notification/m365/UpdateScheduleNotification.vue